const { REACT_APP_API_URL = '' } = process.env

export const NAMESPACE = 'sms'

export const ENDPOINTS = {
  SEND_SMS: `${REACT_APP_API_URL}/sms/send`,
  GET_OTP: `${REACT_APP_API_URL}/user/otp/email`,
}
